import { render } from "./ModuleBlockEditable.vue?vue&type=template&id=255e2682"
import script from "./ModuleBlockEditable.vue?vue&type=script&lang=js"
export * from "./ModuleBlockEditable.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__